// Import model
import { OtgVinylCatalogStyleCondition } from '../models/OtgVinylCatalogStyleCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { OtgVinylCatalogStyleIndexedFields } from '../models/OtgVinylCatalogStyleIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { OtgVinylCatalogStyleIndexedFieldsSerializer } from './OtgVinylCatalogStyleIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for OtgVinylCatalogStyleCondition - handles JSON serialization and deserialization with type validation
 */
export class OtgVinylCatalogStyleConditionSerializer {
  /**
   * Deserializes a JSON string into a OtgVinylCatalogStyleCondition instance
   */
  static deserialize(json: string): OtgVinylCatalogStyleCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a OtgVinylCatalogStyleCondition instance
   */
  static fromObject(obj: any): OtgVinylCatalogStyleCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to OtgVinylCatalogStyleCondition');
    }


    const instance: OtgVinylCatalogStyleCondition = {
      fieldName: obj['fieldName'] as OtgVinylCatalogStyleIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of OtgVinylCatalogStyleCondition instances
   */
  static deserializeArray(json: string): OtgVinylCatalogStyleCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a OtgVinylCatalogStyleCondition instance to a JSON string
   */
  static serialize(instance: OtgVinylCatalogStyleCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a OtgVinylCatalogStyleCondition instance to a plain object
   */
  static toObject(instance: OtgVinylCatalogStyleCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of OtgVinylCatalogStyleCondition instances to a JSON string
   */
  static serializeArray(instances: OtgVinylCatalogStyleCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
